"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const image_1 = __importDefault(require("next/image"));
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const helpers_1 = require("../../lib/helpers");
const Journey_1 = require("../../lib/Journey");
const Img = (props) => {
    const { size } = props;
    const { src } = props;
    const primitiveProps = helpers_1.usePrimitiveProps(props);
    if (!Journey_1.Journey.config.imageOptimizer) {
        const style = Object.assign(Object.assign({}, primitiveProps.style), { width: size && size !== 'auto' ? size.w : undefined, height: size && size !== 'auto' ? size.h : undefined });
        // eslint-disable-next-line jsx-a11y/alt-text
        return react_1.default.createElement("img", Object.assign({}, primitiveProps, { style: style }));
    }
    const height = size && typeof size !== 'string' ? size.h : undefined;
    const width = size && typeof size !== 'string' ? size.w : undefined;
    return (react_1.default.createElement(image_1.default, Object.assign({ height: height, width: width }, helpers_1.without(props, ['forwardedRef']), { src: src })));
};
exports.default = withJourney_1.default('j-img', Img);
